export default [
  { label: 'ride_search_page', value: 'ride_search_page' },
];
